<template>
<div style="height:100%">
  <div id="csContainer">
      <el-button  class="rotate" size="small" type="primary" @click="rotate()" >绕点飞行</el-button>
<!--      <el-input size="small " class="speed" placeholder="旋转速率：默认每秒6度" v-model = 'speed' clearable></el-input>-->
<!--      <el-button class="submit" @click="setSpeed()" size="small "slot="append" icon="el-icon-circle-check" type="primary" >设置</el-button>-->
  </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'rotate',
        data(){
            return{
                viewer: null,
            }
        },
        mounted(){
             var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        methods:{
            init(){
                this.viewer = util.getViewer("csContainer");
            },
            rotate(){
                let viewer = this.viewer;
                var options = {
                    lng: -75.62898254394531,
                    lat: 40.02804946899414,
                    height:  0.0,
                    heading: 0.0,
                    pitch: 0.0,
                    roll: 0.0
                };
                // var entity = viewer.entities.add({
                //     position: Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414),
                //     point: {
                //         color: Cesium.Color.BLUE,
                //         pixelSize: 25
                //     }
                // });

                this.modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 0.0));

                this.model = viewer.scene.primitives.add(Cesium.Model.fromGltf({
                    url : "/demo/static/data/models/car.glb",
                    modelMatrix : this.modelMatrix,
                    scale : 5
                }));
                var position = Cesium.Cartesian3.fromDegrees(options.lng, options.lat, options.height);

                var pitch = Cesium.Math.toRadians(-45);
                // 给定飞行一周所需时间，比如10s, 那么每秒转动度数
                var angle = 360 / 60;
                // 给定相机距离点多少距离飞行，这里取值为5000m
                var distance = 100;
                var startTime = Cesium.JulianDate.fromDate(new Date());

                // var stopTime = Cesium.JulianDate.addSeconds(startTime, 10, new Cesium.JulianDate());

                viewer.clock.startTime = startTime.clone();  // 开始时间
                // viewer.clock.stopTime = stopTime.clone();     // 结束时间
                viewer.clock.currentTime = startTime.clone(); // 当前时间
                viewer.clock.clockRange = Cesium.ClockRange.CLAMPED; // 行为方式
                viewer.clock.clockStep = Cesium.ClockStep.SYSTEM_CLOCK; // 时钟设置为当前系统时间; 忽略所有其他设置。

                // 相机的当前heading
                var initialHeading = viewer.camera.heading;
                var Exection = function TimeExecution() {
                    // 当前已经过去的时间，单位
                    var delTime = Cesium.JulianDate.secondsDifference(viewer.clock.currentTime, viewer.clock.startTime);
                    var heading = Cesium.Math.toRadians(delTime * angle) + initialHeading;

                    viewer.scene.camera.setView({
                        destination :position, // 点的坐标
                        orientation:{
                            heading: heading,
                            pitch : pitch,
                        }
                    });
                    viewer.scene.camera.moveBackward(distance);

                    if (Cesium.JulianDate.compare(viewer.clock.currentTime, viewer.clock.stopTime) >= 0) {
                        viewer.clock.onTick.removeEventListener(Exection);
                    }
                };
                viewer.clock.onTick.addEventListener(Exection);
            }

        }
    }
</script>
<style scoped>
  .rotate {
    position: absolute;
    margin-left: 25px;
    margin-top: 7px;
    z-index: 999;
  }
  .speed{
      position: absolute;
      width:200px;
      margin-left: 20px;
      margin-top:10px;
      z-index: 999;
  }
  .submit {
      position: absolute;

      margin-left: 225px;
      margin-top:10px;
      z-index: 999;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
